
/**
 * Expected properties and functions for configuration widgets
 * that are used as part of the `DashboardItemConfig.vue` system.
 * These are typically widgets displayed inside DashboardItemConfig.vue and DashboardItemConfigExpanded.vue.
 * (I.E. if your widget uses DashboardWidgetConfigurationSection or MultiConfigDisplay,
 * then your config widget that is set inside those should use this mixin).
 *
 * Items used inside a MultiConfigDisplay should also use this mixin.
 */
export default {
    props: {
        // Type of dashboard we are working with
        dashboardType: {type: String, default: ''},
        // Type of widget we are working with
        widgetType: {type: String, default: ''},
        // This prop will be filled with the configuration props for a widget.
        // It will default with the values from DashboardWidget.getDefaultProps() for
        // the selected widget type.
        config: {type: Object, default: () => ({})},
        // True when being rendered inside `DashboardItemConfigExpanded.vue`
        sideBySideMode: {type: Boolean, default: false},
        // Entire Dashboard object
        dashboard: {type: Object, default: () => ({})},
        /**
         * If the config widget is being displayed inside a DashboardItemFilterBar
         */
        inFilterBarDisplay: {type: Boolean, default: false}
    },
    methods: {
        /**
         * This method should be called to tell `DashboardItemConfig.vue` that the config has been updated.
         * @param {*} key - Key on the config to patch
         * @param {*} value - Value to patch for specified key
         */
        sendConfigUpdate: function (key, value) {
            this.$emit('onUpdate', key, value);
        },
        /**
         * Tell `DashboardItemConfig.vue` to go back to main sections page
         */
        goBackToSections: function () {
            this.$emit('onGoBack');
        },
        /**
         * Returns a DashboardValidationResults of the validation state of the config
         * including the sent changes. configChange should be proposed config change that
         * will be assigned to the current config before running it through validation.
         *
         * @param {object} configChange
         */
        checkConfigValidity: function (configChange = {}) {
            const widgetDefinition = MeadCommon.DashboardService.getWidgetDefinition(this.widgetType);
            if (widgetDefinition === undefined) return new MeadCommon.DashboardValidationResults();
            return widgetDefinition.isConfigValid(Object.assign({}, this.config, configChange));
        }
    },
}